import { render, staticRenderFns } from "./AmountCYInputAnyPageNew.vue?vue&type=template&id=27da2070&scoped=true"
import script from "./AmountCYInputAnyPageNew.vue?vue&type=script&lang=js"
export * from "./AmountCYInputAnyPageNew.vue?vue&type=script&lang=js"
import style0 from "./AmountCYInputAnyPageNew.vue?vue&type=style&index=0&id=27da2070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27da2070",
  null
  
)

export default component.exports